<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import AlertBox from '@/components/Elements/Alerts/AlertBox.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { handleNext } from '../tutorialSteps'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_diplomacy')
}

const isOnDiplomacySection = computed(() => {
  return route.path.startsWith('/diplomacy')
})

const goToDiplomacy = () => {
  router.push('/diplomacy')
}
</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/government.webm"
  >
    <template #text>
      <p class="pb-2">
        {{ t('tutorial.diplomacy.overview.seeAll') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.diplomacy.overview.scannerInfo') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.diplomacy.overview.requestPacts') }}
      </p>
    </template>

    <template #alerts>
      <AlertBox type="info">
        {{ t('tutorial.diplomacy.overview.clickName') }}
      </AlertBox>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnDiplomacySection" @click="goToDiplomacy" class="mr-2">
        {{ t('tutorial.diplomacy.overview.goToDiplomacy') }}
      </ActionButton>
      <ActionButton @click="handleNextStep">
        {{ t('common.actions.understood') }}
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">

</style>